export const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      id: row['businesssubscription_user_id'],
      followDate: row['businesssubscription_subscriptiondate_persian_date'],
      followTime: row['businesssubscription_subscriptiondate_persian_time'],
      userId: row['customer_user_id'],
      ssoId: row['customer_firstname'],
      firstName: row['customer_firstname'],
      lastName: row['customer_lastname'],
      phoneNumber: row['customer_cellphonenumber'],
      nationalId: row['customer_nationalcode'],
    };
  });

  return newData;
};
